import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UserHeaderComponent } from '../../user-header/user-header.component';

@Component({
    selector: 'app-usergroup-edit',
    imports: [
        UserHeaderComponent
    ],
    templateUrl: './usergroup-edit.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './usergroup-edit.component.scss'
})
export class UsergroupEditComponent {

}
